import React from 'react'
import ReactDOM from 'react-dom'
import FeaturedCarsSlider from './FeaturedCarsSlider'

export const renderFeaturedCarsSlider = (carouselStore) => {
  // const slider = document.querySelector('[data-react-component=FeaturedCarsSlider]')
  const _sliders = document.getElementsByClassName('sliding-featured-list')
  const sliders = Array.from(_sliders)

  if (sliders) {
    sliders.forEach((slider, i) => {
      const country = slider.getAttribute('data-country')
      const featuredCarsUrl = slider.getAttribute('data-featured-cars-url')
      const emissionInformation = slider.getAttribute('data-emission-information')
      const reverseList = slider.getAttribute('data-reverse-list')
      const sectionHeadline = slider.getAttribute('data-section-headline')
      const sliderRef = slider.getAttribute('data-slider-ref')
      const usePageNavigation = slider.getAttribute('data-use-page-navigation')
      const searchResultsV2 = slider.getAttribute('data-search-results-v-2')
      const lazyload = slider.hasAttribute('data-lazyload')
      const version = slider.getAttribute('data-version')
      const eagerloadCount = (slider.hasAttribute('data-eagerload-count') &&
        parseInt(slider.getAttribute('data-eagerload-count'))) || undefined
      if (lazyload) {
        slider.setAttribute('data-lazyload-trigger', 'listingCarouselViewed')
      }
      slider.setAttribute('data-carousel-nr', i)
      let cars = slider.getAttribute('data-cars')
      if (cars) {
        cars = JSON.parse(cars)
      }

      const reactEl = ReactDOM.render(
        <FeaturedCarsSlider
          featuredCarsUrl={featuredCarsUrl}
          country={country}
          emissionInformation={emissionInformation}
          reverseList={reverseList}
          sectionHeadline={sectionHeadline}
          sliderRef={sliderRef}
          cars={cars}
          usePageNavigation={usePageNavigation}
          searchResultsV2={searchResultsV2}
          lazyload={lazyload}
          eagerloadCount={eagerloadCount}
          version={version}
        />, slider
      )

      if (carouselStore) {
        carouselStore[i] = reactEl
      }

      return reactEl
    })
  }
}

export default () => {
  let carousels = {}

  window.listingCarouselViewed = (carouselNode) => {
    const carouselNr = carouselNode.getAttribute('data-carousel-nr')
    const newProps = { ...carousels[carouselNr].props, willBeInView: true }
    ReactDOM.render(
      <FeaturedCarsSlider {...newProps} />,
      carouselNode
    )
  }

  document.addEventListener('DOMContentLoaded', () => {
    renderFeaturedCarsSlider(carousels)
  })
}
